import RouteParam from '@/_constants/RouteParam.ts';

const Routes = Object.freeze({
  HOME: '/',
  LOGIN: '/login',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  ADMIN__DASHBOARD: '/admin',
  ADMIN__RESTAURANTS: '/admin/restaurants',
  ADMIN__RESTAURANTS__RESERVATIONS: `/admin/restaurants/:${RouteParam.RESTAURANT_ID}/reservations`,
  ADMIN__RESTAURANTS__RESERVATIONS__LOGS: `/admin/restaurants/:${RouteParam.RESTAURANT_ID}/reservations/:${RouteParam.RESERVATION_ID}/logs`,
  ADMIN__FAQ: '/admin/faq',
  ADMIN__INTEGRATIONS: '/admin/integrations',
  MANAGER__DASHBOARD: '/manager',
  MANAGER__RESERVATIONS: '/manager/reservations',
  MANAGER__RESERVATIONS__LOGS: `/manager/reservations/:${RouteParam.RESERVATION_ID}/logs`,
} as const);

export default Routes;

export type AvailableRoutes = (typeof Routes)[keyof typeof Routes];
